export default __webpack_public_path__ + "static/palette-jira-board-light-e5ca35aa91d9d72f0f3a499528a3cd82533eeba8f018f17bb6e015cc80e47953.png";